import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordForm } from "components/Forms/ForgotPasswordForm/ForgotPasswordForm.tsx";
import { AuthLink } from "components/UI/AuthLink/AuthLink.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const Route = createFileRoute("/$tenantSlug/auth/_layout/forgot-password/")({
    component: ForgotPasswordPage,
});

function ForgotPasswordPage() {
    const { t: tAuth } = usePaldockTranslation("auth.forgot-password");
    const { t: tAuthLogin } = usePaldockTranslation("auth.login");
    const { tenantSlug } = Route.useParams();

    return (
        <AuthPageContainer title={tAuth("title")}>
            <ForgotPasswordForm
                returnUrl={`${import.meta.env.VITE_APP_URL}/${tenantSlug}/auth/change-password`}
            />
            <div className="flex justify-center mt-4 text-md text-black">
                {tAuthLogin("messages.no_account")}{" "}
                <AuthLink to="/$tenantSlug/auth/registration" params={{ tenantSlug }} className="ml-1">
                    {tAuthLogin("links.register")}
                </AuthLink>
            </div>
        </AuthPageContainer>
    );
}
